'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _admin = require('./admin.component');

var _admin2 = _interopRequireDefault(_admin);

var _entity = require('./entity/entity');

var _entity2 = _interopRequireDefault(_entity);

var _list = require('./entity/list/list');

var _list2 = _interopRequireDefault(_list);

var _enquiryExtraManagement = require('./enquiryExtraManagement/enquiryExtraManagement');

var _enquiryExtraManagement2 = _interopRequireDefault(_enquiryExtraManagement);

var _financialProductManagement = require('./financialProductManagement/financialProductManagement');

var _financialProductManagement2 = _interopRequireDefault(_financialProductManagement);

var _enquirySourceManagement = require('./enquirySourceManagement/enquirySourceManagement');

var _enquirySourceManagement2 = _interopRequireDefault(_enquirySourceManagement);

var _retailPriceList = require('./retailPriceList/retailPriceList');

var _retailPriceList2 = _interopRequireDefault(_retailPriceList);

var _vehicleTradersManagement = require('./vehicleTradersManagement/vehicleTradersManagement');

var _vehicleTradersManagement2 = _interopRequireDefault(_vehicleTradersManagement);

var _financeCompaniesManagement = require('./financeCompaniesManagement/financeCompaniesManagement');

var _financeCompaniesManagement2 = _interopRequireDefault(_financeCompaniesManagement);

var _deliveryPriceManagement = require('./deliveryPriceManagement/deliveryPriceManagement');

var _deliveryPriceManagement2 = _interopRequireDefault(_deliveryPriceManagement);

var _defaultTextManagement = require('./defaultTextManagement/defaultTextManagement');

var _defaultTextManagement2 = _interopRequireDefault(_defaultTextManagement);

var _brandModelManagement = require('./brandModelManagement/brandModelManagement');

var _brandModelManagement2 = _interopRequireDefault(_brandModelManagement);

var _failedWebEnquiries = require('./failedWebEnquiries/failedWebEnquiries');

var _failedWebEnquiries2 = _interopRequireDefault(_failedWebEnquiries);

var _autoPromiseManagement = require('./autoPromiseManagement/autoPromiseManagement');

var _autoPromiseManagement2 = _interopRequireDefault(_autoPromiseManagement);

var _monthlyDistributionManagement = require('./monthlyDistributionManagement/monthlyDistributionManagement');

var _monthlyDistributionManagement2 = _interopRequireDefault(_monthlyDistributionManagement);

var _userTargetsManagement = require('./userTargetsManagement/userTargetsManagement');

var _userTargetsManagement2 = _interopRequireDefault(_userTargetsManagement);

var _entityPreferences = require('./entityPreferences/entityPreferences');

var _entityPreferences2 = _interopRequireDefault(_entityPreferences);

var _reportsAccess = require('./reportsAccess/reportsAccess');

var _reportsAccess2 = _interopRequireDefault(_reportsAccess);

var _dataUtility = require('./dataUtility/dataUtility');

var _dataUtility2 = _interopRequireDefault(_dataUtility);

var _scheduledReportsManagement = require('./scheduledReportsManagement/scheduledReportsManagement');

var _scheduledReportsManagement2 = _interopRequireDefault(_scheduledReportsManagement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adminModule = _angular2.default.module('admin', [_angularUiRouter2.default, _entity2.default, _enquiryExtraManagement2.default, _financialProductManagement2.default, _enquirySourceManagement2.default, _retailPriceList2.default, _vehicleTradersManagement2.default, _financeCompaniesManagement2.default, _deliveryPriceManagement2.default, _defaultTextManagement2.default, _brandModelManagement2.default, _failedWebEnquiries2.default, _autoPromiseManagement2.default, _monthlyDistributionManagement2.default, _userTargetsManagement2.default, _entityPreferences2.default, _reportsAccess2.default, _dataUtility2.default, _scheduledReportsManagement2.default]).config(function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('admin', {
    url: '/admin',
    component: 'admin'
  });

  $stateProvider.state('admin.listEntities', {
    url: '/listEntities',
    component: 'list'
  });
}).component('admin', _admin2.default).name;

exports.default = adminModule;


// WEBPACK FOOTER //
// ./client/app/components/admin/admin.js